import React from "react"

import "./faded_line.scss"

const FadedLine = () => <div className="FadedLine" />

export default FadedLine
